import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import ToggleSwitch from "../../../components/Settings/suppliers/ToggleSwitch";
import updateFlightSetting from "../../../controllers/settings/supplier/updateFlightSetting";

const POST_TICKETING_FIELDS = [
  { key: "changeEnabledSuppliers", label: "Change" },
  { key: "refundEnabledSuppliers", label: "Refund" },
  { key: "voidEnabledSuppliers", label: "Void" },
  { key: "autoChangeEnabledSuppliers", label: "Auto Change" },
  { key: "autoRefundEnabledSuppliers", label: "Auto Refund" },
  { key: "autoVoidEnabledSuppliers", label: "Auto Void" },
];

function normalizeList(list) {
  return Array.isArray(list) ? list : [];
}

export default function PostTicketingSettings({
  data,
  supplierCode,
  supplierName,
  callback,
}) {
  const [settings, setSettings] = useState({});
  const [loadings, setLoadings] = useState({});

  useEffect(() => {
    const next = {};
    POST_TICKETING_FIELDS.forEach(({ key }) => {
      next[key] = normalizeList(data?.[key]);
    });
    setSettings(next);
  }, [data]);

  async function handleToggle(fieldKey, enabled) {
    const current = normalizeList(settings[fieldKey]);
    const nextList = enabled
      ? [...current.filter((code) => code !== supplierCode), supplierCode]
      : current.filter((code) => code !== supplierCode);

    setSettings((prev) => ({ ...prev, [fieldKey]: nextList }));
    setLoadings((prev) => ({ ...prev, [fieldKey]: true }));

    const res = await updateFlightSetting({ [fieldKey]: nextList });
    setTimeout(
      () => setLoadings((prev) => ({ ...prev, [fieldKey]: false })),
      400,
    );

    if (res.return) {
      enqueueSnackbar("Successful", { variant: "success" });
      callback && callback();
    } else {
      setSettings((prev) => ({ ...prev, [fieldKey]: current }));
      enqueueSnackbar(res.msg, { variant: "error" });
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <span className="block text-sm text-gray-600">
        Toggle post-ticketing actions for{" "}
        <span className="font-medium text-gray-800">
          {supplierName || supplierCode}
        </span>
        .
      </span>
      <div className="flex flex-col gap-3">
        {POST_TICKETING_FIELDS.map(({ key, label }) => {
          const enabled = normalizeList(settings[key]).includes(supplierCode);
          return (
            <div
              key={key}
              className="flex items-center justify-between gap-4 border rounded-md px-3 py-2"
            >
              <span className="text-sm font-medium">{label}</span>
              <div className="flex items-center justify-center min-w-[40px] min-h-[28px]">
                {loadings[key] ? (
                  <CircularProgress size={16} />
                ) : (
                  <ToggleSwitch
                    toggleValue={enabled}
                    callback={(val) => handleToggle(key, val)}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
